class AbstractSubscriberService extends BaseService
	###
  @returns {bool} If this subscriber supports shop_id setting
	###
	hasShop: ->
		@__abstract('hasShop')

	###
  @returns {bool} If this subscriber supports register_id setting
	###
	hasRegister: ->
		@__abstract('hasRegister')

	###
	@returns {null|array} List of SubscriberPeriod that this subscriber is using
	###
	getPeriods: ->
		@__abstract('getPeriods')

	###
	@returns {array} List of field names that this subscriber is requiring
	###
	getRequiredFields: ->
		return []
